import React from "react";
import LabelChip from "../components/LabelChip";
import { base64ToImage, renderVerbatimTranslation } from "../utils/VerbatimUtils";
import "./VerbatimModal.css";

const VerbatimModal = ({ verbatim, onClose, labelTypes }) => {
  if (!verbatim) return null;

  const renderVerbatimContent = (verbatim) => {
    const content = verbatim.verbatim;
    // Pour les verbatims de l'ancien format (chaîne de texte simple)
    if (typeof content === 'string') {
      return (
        <>
          <p>{content}</p>
          {renderVerbatimTranslation(verbatim.translation)}
        </>
      );
    }

    // Pour les verbatims du nouveau format (tableau de blocs texte/image)
    if (Array.isArray(content)) {
      return (
        <div className="review-verbatim-content">
          {content.map((item, index) => {
            if (item.type === 'text' && item.content.trim() !== '') {
              return <p key={index}>{item.content}</p>;
            } else if (item.type === 'image' && item.content) {
              return (
                <div key={index} className="review-image-block">
                  <img 
                    src={base64ToImage(item.content)} 
                    alt="Verbatim" 
                    className="review-verbatim-image"
                    onError={(e) => {
                      console.error("Erreur de chargement de l'image", e);
                      e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiM5OTkiPkltYWdlIEVycm9yPC90ZXh0Pjwvc3ZnPg==";
                    }}
                  />
                </div>
              );
            }
            return null;
          })}
          {renderVerbatimTranslation(verbatim.translation)}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content verbatim-modal">
        {/* Header */}
        <div className="modal-header">
          <h3>Verbatim Details</h3>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Verbatim Content */}
          <div className="verbatim-box">
            {renderVerbatimContent(verbatim)}
          </div>

          {/* Label Details */}
          <div className="label-details">
            {Object.keys(labelTypes).map((labelType) => (
              <div key={labelType} className="label-type-box">
                <strong>{labelType}:</strong>
                <div className="label-chips-container">
                  {Array.isArray(verbatim.labels?.[labelType]) &&
                    verbatim.labels[labelType]
                      .filter((l) => l?.name)
                      .map((l) => (
                        <LabelChip
                          key={l.name}
                          type={labelType}
                          name={l.name}
                          state={l.state}
                        />
                      ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="primary-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerbatimModal;
